import { render, staticRenderFns } from "./CardsEditFormSidebar.vue?vue&type=template&id=0931b104&scoped=true"
import script from "./CardsEditFormSidebar.vue?vue&type=script&lang=js"
export * from "./CardsEditFormSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0931b104",
  null
  
)

export default component.exports